export default __webpack_public_path__ + "static/media/Dread_Pirate_Drool_Beard.6729e1e7.png";